import { kitById } from '@penalty-cup/shared';

const SHIRT = 'M18 8 L8 16 L12 26 L18 23 L18 52 L42 52 L42 23 L48 26 L52 16 L42 8 L36 12 Q30 15 24 12 Z';

/** Футболка в цветах формы (обычной или премиальной из магазина). */
export function Jersey({ kit, className }: { kit: string | null | undefined; className?: string }) {
  const k = kitById(kit);
  return (
    <svg className={`jersey ${className ?? ''}`} viewBox="0 0 60 60" aria-hidden="true">
      <path d={SHIRT} fill={k.color} stroke={k.accent} strokeWidth="2" />
      {k.premium && <path d="M24 12 Q30 15 36 12 L30 30 Z" fill={k.accent} opacity="0.85" />}
    </svg>
  );
}
